import { Injectable } from "@angular/core";
import { ImageProcessor } from "controls";
import { Observable, of } from "rxjs";

@Injectable()
export class ImageProcessorImpl extends ImageProcessor {
    process(data: Blob): Observable<Blob> {
        return of(data);
    }
}
